var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.443 17.48L6.34 17.4c-1.329-.028-2.66.028-3.963-.265-1.981-.44-2.122-2.591-2.269-4.396A33.404 33.404 0 01.366 5.1C.582 3.688 1.43 2.846 2.743 2.754c4.43-.333 8.888-.293 13.308-.138.467.014.937.092 1.397.18 2.272.432 2.328 2.87 2.475 4.924a30.244 30.244 0 01-.196 6.218c-.225 1.705-.656 3.136-2.475 3.274-2.278.18-4.504.326-6.79.28 0-.012-.012-.012-.019-.012zm-2.412-4.318c1.717-1.068 3.401-2.12 5.108-3.181-1.72-1.07-3.401-2.12-5.108-3.182v6.363z",
    fill: "#fff"
  })));
}

export default SvgYoutubeinline;